import { Alert, Button, Card, Form, Input } from "antd";
import Password from "antd/lib/input/Password";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import loginService from "../../services/loginService";
import useAuthorizationData from "../../utils/useAuthorizationData";
import "./LoginForm.css";
import MainLanding from "../../img/main-landing.png";
import RescoStorage from "../../utils/rescoStorage";

const LoginForm = () => {
  const history = useHistory();

  const [login, setLogin] = useState<string>();
  const [password, setPassword] = useState<string>();
  const [loginFailed, setLoginFailed] = useState<boolean>(false);
  const [, setAuthorizationData] = useAuthorizationData();
  const [apiCallInProgess, setApiCallInProgress] = useState<boolean>(false);

  const handleSubmit = async (event: React.FormEvent) => {
    setApiCallInProgress(true);
    const loginResult = await loginService.Login(
      login!,
      Buffer.from(password!).toString("base64")
    );
    setApiCallInProgress(false);
    const loginSuccess = loginResult.status === 200;

    if (!loginSuccess && loginResult.statusText?.length > 0) {
      setLoginFailed(true);
      return;
    }

    if (loginSuccess && loginResult.data.access_token) {
      RescoStorage.removeShip();
      setLoginFailed(false);
      setAuthorizationData(loginResult.data);
      history.push("/visit");
    } else {
      setLoginFailed(true);
    }
  };

  return (
    <>
      <div className="landing-page">
        <img src={MainLanding} className="page-image" alt="" />
      </div>
      <div className="page-card">
        <Card className="page-card-element">
          <h1 className="login-card-title">Log in</h1>
          <Form
            name="basic"
            className=""
            onChange={(e) => setLoginFailed(false)}
            onFinish={(e) => handleSubmit(e)}
            layout="vertical"
          >
            <Form.Item
              className="page-card-form-item"
              label="Email address:"
              name="login"
              rules={[
                {
                  required: true,
                  message: "Please provide your Email address!",
                },
              ]}
            >
              <Input
                className="login-card-form-item-input"
                value={login}
                onChange={(e) => setLogin(e.target.value)}
              />
            </Form.Item>

            <Form.Item
              className="page-card-form-item"
              label="Password:"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please provide your Password!",
                },
              ]}
            >
              <Password
                className="login-card-form-item-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
              />
            </Form.Item>

            <Form.Item className="page-card-form-item">
              {loginFailed ? (
                <Alert message="Login Failed!" type="error" />
              ) : null}
            </Form.Item>

            <Form.Item className="page-card-form-item">
              <Button
                className="page-card-link"
                type="link"
                onClick={() => history.push("/forgotpassword")}
              >
                Forgot Password?
              </Button>
            </Form.Item>
            <Form.Item className="page-card-form-item page-card-form-item-register">
              No account?
              <Button
                className="page-card-link"
                type="link"
                onClick={() => history.push("/register")}
              >
                <span className="login-card-form-item-register-span">
                  Create one!
                </span>
              </Button>
            </Form.Item>

            <Form.Item className="page-card-form-item login-card-form-button">
              <Button
                type="primary"
                className="page-card-button"
                htmlType="submit"
                loading={apiCallInProgess}
              >
                {apiCallInProgess ? "" : "Login"}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </>
  );
};

LoginForm.displayName = "LoginForm";

export default LoginForm;
